// extracted by mini-css-extract-plugin
export default {"info":"InfoBar_info__IA6D4"};